const sortedDiscussionTopicsUuids = (state = [], action) => {
  switch (action.type) {
    case 'WORKSPACE_UPDATE_SORTED_DISCUSSION_TOPIC_UUIDS':
      return action.payload.uuids;
    default:
      return state;
  }
};

export default sortedDiscussionTopicsUuids;
